import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store"; // Asegúrate de importar AppDispatch desde la definición del store

// Definimos el tipo de estado para `loader`
interface LoaderState {
  currentStack: number;
  text: string | null;
}

// Estado inicial de `loader`
const initialState: LoaderState = {
  currentStack: 0,
  text: null,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    increment(state) {
      state.currentStack += 1;
    },
    decrement(state) {
      state.currentStack -= 1;
    },
    changeText(state, action: PayloadAction<string>) {
      state.text = action.payload;
    },
    restart(state) {
      state.currentStack = 0;
    },
  },
});

export const { increment, decrement, changeText, restart } =
  loaderSlice.actions;
export default loaderSlice.reducer;

// Thunks para realizar acciones relacionadas con el loader
export const setShowLoader =
  (isLoading: boolean = true) =>
  async (dispatch: AppDispatch) => {
    if (isLoading) {
      dispatch(increment());
    } else {
      dispatch(decrement());
    }
  };

export const setLoaderText =
  (text: string = "Loading...") =>
  async (dispatch: AppDispatch) => {
    dispatch(changeText(text));
  };

export const setRestartLoader = () => async (dispatch: AppDispatch) => {
  dispatch(restart());
};
